/**
 * @module Components.Subscription.Upgrade
 *
 */
import React from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { cls } from "app/utils";
import LOCALES from "./locale";
import styles from "./styles.module.scss";
import { getSportImage } from "./helper/getSportImage";
import { UserModel } from "app/models";

interface PropsDef {
  onDone: () => void;
  user: UserModel;
  plan?: string;
  isPro?: boolean;
  // The plan was re-priced, not bought: the card may not have been charged
  reprice?: boolean;
}

/**
 * @class SuccessPage
 *
 */
function SuccessPage(props: PropsDef) {
  const isPro = !!props.plan?.startsWith("coachpro");
  const isAnalyze = !!props.plan?.includes("analyze");

  // Each product greets by its own name, and pro and analyze each say what
  // their own plan gives.
  const titleLocale = isPro
    ? LOCALES.success_title_pro
    : isAnalyze
    ? LOCALES.success_title_analyze
    : LOCALES.success_title;

  const bodyLocale = isPro
    ? LOCALES.success_info_two_pro
    : isAnalyze
    ? LOCALES.success_info_two_analyze
    : LOCALES.success_info_two;

  return (
    <div className={styles.successMain}>
      <div className={cls(styles.panel, styles.panelOne)}>
        <div
          className={styles.successImage}
          style={{
            backgroundImage: `url(${getSportImage(props.user?.self?.sport || props.user?.sport)})`,
          }}
        />
      </div>

      <div className={cls(styles.panel, styles.panelTwo)}>
        <div className={styles.panelContainer}>
          <div className={styles.panelHeader}>
            <FormattedMessage
              {...titleLocale}
              values={{ first_name: props.user.firstName }}
            />
          </div>

          <div className={styles.panelBody}>
            <p>
              <FormattedMessage
                {...(props.reprice ? LOCALES.success_info_one_reprice : LOCALES.success_info_one)}
              />
            </p>
            <p>
              <FormattedMessage {...bodyLocale} />
            </p>
            <p>
              {isPro ? (
                <FormattedHTMLMessage {...LOCALES.success_info_three_pro} />
              ) : (
                <FormattedMessage {...LOCALES.success_info_three} />
              )}
            </p>
            <div className="clear-float"></div>
          </div>

          <div className={styles.panelFooter}>
            <a
              className={cls(
                "btn",
                "btn-primary",
                "btn-success",
                styles.doneButton,
              )}
              onClick={() => props.onDone()}
            >
              <FormattedMessage {...LOCALES.success_button} />
            </a>
          </div>

          <div className="clear-float"></div>
        </div>
      </div>
    </div>
  );
}

export default SuccessPage;
